import axios from "axios";
import * as queryString from "query-string";
import constants from "../constants";
import { getToken, removeToken } from './token';


let isRefreshed = false;


const axiosClient = axios.create({
  baseURL: constants.URL_API,
  headers: {
    "content-type": "application/json",
  },

  paramsSerializer: (params) => queryString.stringify(params),
});

axiosClient.interceptors.request.use((config) => {
  const accessToken = getToken("accessToken");
  if (accessToken) {
    config.headers["tk-kelly"] = "jwttoken=" + accessToken;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },

  async (error) => {
    if (error.response) {
      if (error.response.status == 401 && !isRefreshed) {
        isRefreshed = true;
        const accessToken = getToken('accessToken');
        removeToken();
      }
      return error.response;
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
